"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapPickupPoints = function mapPickupPoints(pointsData) {
  var mappedPoints = [];
  if (pointsData != undefined && pointsData.items.length > 0) {
    pointsData.items.map(function (singlePoint) {
      mappedPoints.push({
        id: singlePoint.pickup_location_code,
        label: singlePoint.name + " " + singlePoint.street + " " + singlePoint.city,
        data: singlePoint
      });
    });
    return mappedPoints;
  }
  return null;
};
var _default = mapPickupPoints;
exports["default"] = _default;